import React, { useState, useMemo } from "react";
import { useMutation, useQueryClient } from "react-query";
import moment from "moment";
import useGetter from "../../../../../hooks/queryResults/useGetter";
import useUrls from "../../../../../hooks/useUrls";
import http from "../../../../../services/httpService";
import Util from "../../../../../util/util";
import Table from "../../../../layout/Table";
import Loading from "../../../../ui/Loading";

export default function AdminRemoteNflPlayerSearch() {
  const [query, setQuery] = useState("");
  const [message, setMessage] = useState("");
  const [nflPlayerIds, setNflPlayerIds] = useState([]);
  const queryClient = useQueryClient();
  const { data: nflPlayersData, query: nflPlayersQuery } = useGetter(
    `/nfl/players?q=${query}`,
    { enabled: query.length >= 2 }
  );
  const { apiUrl } = useUrls();

  const queries = [nflPlayersQuery];
  const isLoading = queries.some((query) => query.isLoading);

  const mutation = useMutation(
    () => {
      const data = { nflPlayers: nflPlayerIds };
      const url = `${apiUrl}/admin/remote/merge/nfl-players`;
      const config = Util.addTokenToHeaders();
      console.log(`sending PATCH request to url ${url} with data:`, data);
      return http.patch(url, data, config);
    },
    {
      onSuccess: async () => {
        setMessage("successfully merged players");
        console.log(message);
        await queryClient.invalidateQueries("/nfl/players");
      },
      onError: (error) => {
        setMessage(error.response.data.error);
      },
    }
  );

  const nflPlayerColumns = useMemo(
    () => [
      { Header: "CBS", accessor: "cbs" },
      { Header: "FP", accessor: "fp" },
      { Header: "PFR", accessor: "pfr" },
      { Header: "Pos", accessor: "pos" },
      { Header: "First", accessor: "firstName", className: "left" },
      { Header: "Last", accessor: "lastName", className: "left" },
      { Header: "NFL", accessor: "nflFranchiseAbbr" },
      { Header: "Birth", accessor: "birthDate" },
      { Header: "Merge", accessor: "merge" },
    ],
    []
  );

  const nflPlayerData = useMemo(() => {
    const addNflPlayerId = (nflPlayerId) => {
      if (!nflPlayerIds.includes(nflPlayerId))
        setNflPlayerIds([...nflPlayerIds, nflPlayerId]);
    };

    const removeNflPlayerId = (nflPlayerId) => {
      if (nflPlayerIds.includes(nflPlayerId)) {
        const ids = nflPlayerIds.filter((id) => id !== nflPlayerId);
        setNflPlayerIds(ids);
      }
    };

    if (!nflPlayersData) return [];
    return nflPlayersData.nflPlayers.map((nflPlayer) => {
      return {
        cbs: nflPlayer.cbsId,
        fp: nflPlayer.fpId,
        pfr: nflPlayer.pfrId,
        pos: nflPlayer.pos,
        firstName: nflPlayer.firstName,
        lastName: nflPlayer.lastName,
        nflFranchiseAbbr: nflPlayer.nflFranchiseAbbr,
        birthDate: nflPlayer.birthDate
          ? moment(nflPlayer.birthDate).format("YYYY-MM-DD")
          : null,
        merge: (
          <input
            type={"checkbox"}
            onClick={(event) => {
              console.log("checked", event.target.checked, nflPlayer.id);
              if (event.target.checked) {
                addNflPlayerId(nflPlayer.id);
              } else {
                removeNflPlayerId(nflPlayer.id);
              }
              console.log(nflPlayerIds);
            }}
          />
        ),
      };
    });
  }, [nflPlayersData, nflPlayerIds]);

  return isLoading ? (
    <Loading />
  ) : (
    <div>
      <h1>NFL Player Search & Merge Duplicates</h1>
      Search:
      <input
        type={"text"}
        onChange={async (event) => {
          if (event.target.value.length >= 2) {
            setQuery(event.target.value);
            await queryClient.invalidateQueries("/nfl/players");
            setNflPlayerIds([]);
          }
        }}
      />
      <button
        className={"btn"}
        disabled={nflPlayerIds.length !== 2}
        style={{ marginLeft: "2rem" }}
        onClick={mutation.mutate}
      >
        Merge
      </button>
      <span>{message}</span>
      <Table columns={nflPlayerColumns} data={nflPlayerData} />
    </div>
  );
}
